import { useState } from "react";
import {
  Box,
  Select,
  MenuItem,
  Button,
  Grid,
  FormControl,
  FormHelperText,
  Stack,
  Paper,
  TextField,
  Snackbar,
  Alert,
} from "@mui/material";
import axios from "../../../config/axios";
import CommonDialog from "../../../components/CommonDialog";

const AddLanguageModal = (props) => {
  // modal states
  const [languageData, setLanguageData] = useState({});
  const [validations, setValidations] = useState({
    language: { status: false, msg: "" },
  });
  const [newLanguage, setNewLanguage] = useState("");
  const [alertMsg, setAlertMsg] = useState({});

  // other functions
  const handleSubmit = () => {
    if (isFormValid()) {
      props.setEmployeeData((prevState) => {
        return {
          ...prevState,
          languages: [...prevState.languages, languageData],
        };
      });
      props.setOpen({ ...props.open, addLanguage: false });
      setLanguageData({});
    }
  };

  const isFormValid = () => {
    console.log(languageData);
    if (!languageData?.id || !languageData.id.length) {
      setValidations(() => ({
        language: { status: true, msg: "Required!" },
      }));
      return false;
    }
    // check if already exists
    const langs = props.employeeData?.languages?.map((lang) => lang.id);
    if (langs.includes(languageData?.id)) {
      setValidations(() => ({
        language: { status: true, msg: "Already Exists" },
      }));
      return false;
    }
    return true;
  };

  const addLanguage = () => {
    const body = { name: newLanguage };
    axios
      .post("/admin/languages", body)
      .then((res) => {
        if (res.status === 200) {
          if (res.data.status) {
            setAlertMsg({ status: true, msg: "Language added successfully!" });
            setValidations({});
            setNewLanguage("");
            props.fetchLanguageOptions();
          } else {
            if (res.data.type === "validation" && res.data.error) {
              const tempValidations = {};
              res.data.error.forEach((val) => {
                tempValidations.newLanguage = {
                  status: true,
                  msg: val.message,
                };
              });
              setValidations((prevState) => ({
                ...prevState,
                ...tempValidations,
              }));
            }
          }
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      <CommonDialog
        open={props.open.addLanguage}
        title={"Add Language"}
        onSubmit={handleSubmit}
        onClose={() => props.setOpen({ ...props.open, addLanguage: false })}
      >
        <Paper style={{ ...props.style, width: "100%" }} elevation={0}>
          <Box sx={{ padding: "10px" }}>
            <Stack spacing={1}>
              <Grid container spacing={1}>
                <Grid xs={12} sm={12} md={12} lg={12} xl={12} item>
                  <Grid container spacing={1}>
                    <Grid xs={9} sm={9} md={9} lg={9} xl={10} item>
                      <TextField
                        size="small"
                        placeholder={"Language"}
                        value={newLanguage}
                        onChange={(e) => setNewLanguage(e.target.value)}
                        error={validations.newLanguage?.status}
                        helperText={validations.newLanguage?.msg}
                        fullWidth
                      />
                    </Grid>
                    <Grid xs={3} sm={3} md={3} lg={3} xl={2} item>
                      <Button
                        variant="contained"
                        onClick={addLanguage}
                        sx={{ width: "100%" }}
                      >
                        add
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid xs={12} sm={12} md={12} lg={12} xl={12} item>
                  <FormControl
                    error={validations.language?.status}
                    sx={{ width: "100%" }}
                  >
                    <Select
                      size="small"
                      value={languageData.name}
                      onChange={(e) => {
                        const opt = props.activeLanguages.filter(
                          (lang) => lang.id === e.target.value
                        );
                        setLanguageData({ ...opt[0], value: 3 });
                      }}
                      displayEmpty={true}
                      renderValue={() => {
                        const styles = {};
                        const value = languageData.name
                          ? props.activeLanguages?.filter(
                              (opt) => opt.id === languageData.id
                            )[0]?.name
                          : "Select";
                        if (value === "Select") {
                          styles.color = "#919fa5";
                        }
                        return <div style={styles}>{value}</div>;
                      }}
                    >
                      {props.activeLanguages?.map((lang) => (
                        <MenuItem value={lang.id}>{lang.name}</MenuItem>
                      ))}
                    </Select>
                    {validations.language?.status ? (
                      <FormHelperText>
                        {validations.language?.msg}
                      </FormHelperText>
                    ) : null}
                  </FormControl>
                </Grid>
              </Grid>
            </Stack>
          </Box>
        </Paper>
      </CommonDialog>

      <Snackbar
        open={alertMsg.status}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        autoHideDuration={2000}
        onClose={() => setAlertMsg({})}
      >
        <Alert severity={alertMsg.severity} sx={{ width: "100%" }}>
          {alertMsg.msg}
        </Alert>
      </Snackbar>
    </>
  );
};

export default AddLanguageModal;
